const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

export const fmtCurrency = (v) => {
  const n = Number(v) || 0;
  return currencyFormatter.format(n);
};

export const fmtPercent = (v) => `${(Number(v) || 0).toFixed(2)}%`;

export const fmtNumber = (v) => numberFormatter.format(Number(v) || 0);
